document.addEventListener("DOMContentLoaded", function () {
  const swipers = [];
  document
    .querySelectorAll(".product-content .product-video-swiper")
    .forEach((swiperEl) => {
      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: swiperEl.querySelector(".swiper-button-next"),
          prevEl: swiperEl.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: swiperEl.querySelector(".swiper-pagination"),
          type: "fraction",
        },
        on: {
          slideChangeTransitionEnd: function () {
            const target = swiperEl.closest(".product-content");
            autoPlayActiveSlideVideo(target);
          },
        },
      });
      swipers.push({ el: swiperEl, instance: swiper });
    });

  // nav-item 点击切换
  const navItems = document.querySelectorAll(
    ".common-product-with-video .nav-item"
  );
  const products = document.querySelectorAll(
    ".common-product-with-video .product-content"
  );

  function activateProduct(index) {
    if (index < 0) index = navItems.length - 1;
    if (index >= navItems.length) index = 0;

    navItems.forEach((i) => i.classList.remove("active"));
    products.forEach((c) => c.classList.remove("active"));

    const activeItem = navItems[index];
    const targetProduct = activeItem.getAttribute("data-product");
    const target = document.querySelector(
      `.product-content[data-product="${targetProduct}"]`
    );

    activeItem.classList.add("active");
    if (target) {
      // 显示选中nav-item对应的product-content
      target.classList.add("active");
      syncHeight();
      updateThumbnail();
      const swiperData = swipers.find(
        (s) => s.el === target.querySelector(".swiper")
      );
      if (swiperData) swiperData.instance.update();

      autoPlayActiveSlideVideo(target);
    }

    // 让当前 active item 滚动到左边
    activeItem.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start", // 靠左对齐
    });
  }

  navItems.forEach((item, idx) => {
    item.addEventListener("click", () => {
      activateProduct(idx);
      updateDisableClass();
    });
  });

  const prevBtn = document.querySelector(
    ".common-product-with-video .nav-btn .icon-swiper-prev"
  );
  const nextBtn = document.querySelector(
    ".common-product-with-video .nav-btn .icon-swiper-next"
  );

  function getActiveIndex() {
    return Array.from(navItems).findIndex((i) =>
      i.classList.contains("active")
    );
  }

  prevBtn?.addEventListener("click", () => {
    const current = getActiveIndex();
    if (current != 0) {
      prevBtn.classList.remove("disable");
      activateProduct(current - 1);
    }
    updateDisableClass();
  });

  nextBtn?.addEventListener("click", () => {
    const current = getActiveIndex();
    if (current != navItems.length - 1) {
      nextBtn.classList.remove("disable");
      activateProduct(current + 1);
    }
    updateDisableClass();
  });

  // 统一控制按钮状态
  function updateDisableClass() {
    const current = getActiveIndex();

    if (current <= 0) {
      prevBtn.classList.add("disable");
    } else {
      prevBtn.classList.remove("disable");
    }

    if (current >= navItems.length - 1) {
      nextBtn.classList.add("disable");
    } else {
      nextBtn.classList.remove("disable");
    }
  }
  updateDisableClass();

  function syncHeight() {
    const left = document.querySelector(
      ".product-content.active .thumbnail-wrapper"
    );
    left.style.height = 0;
    const right = document.querySelector(
      ".product-content.active .grid-product"
    );
    left.style.height = right.offsetHeight + "px";
  }

  window.addEventListener("load", syncHeight);
  window.addEventListener("resize", syncHeight);

  function updateThumbnail() {
    const activeContent = document.querySelector(
      ".common-product-with-video .product-content.active"
    );
    if (!activeContent) return;

    const thumbnails = activeContent.querySelectorAll(".thumbnail");
    const mainImage = activeContent.querySelector(".product--image");

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", () => {
        // 移除旧 active
        thumbnails.forEach((t) => t.classList.remove("active"));
        thumbnail.classList.add("active");

        const container = thumbnail.closest(".thumbnail-wrapper"); // 找到可滚动的父容器
        if (container) {
          const top = thumbnail.offsetTop - container.offsetTop; // 当前缩略图相对容器的偏移
          container.scrollTo({
            top,
            behavior: "smooth",
          });
        }

        // 替换主图
        const newSrc = thumbnail.getAttribute("src");
        if (mainImage && newSrc) {
          // 暂时禁用懒加载属性
          mainImage.removeAttribute("srcset");
          mainImage.removeAttribute("data-srcset");
          mainImage.removeAttribute("data-src");
          mainImage.removeAttribute("sizes");

          // 平滑切换
          mainImage.style.transition = "opacity 0.3s ease";
          mainImage.style.opacity = "0";

          setTimeout(() => {
            mainImage.setAttribute("src", newSrc);
            mainImage.style.opacity = "1";
          }, 50);
        }
      });
    });
  }
  updateThumbnail();

  function pauseAllVideos() {
    const iframes = document.querySelectorAll(".product-video-swiper iframe");
    iframes.forEach((iframe) => {
      try {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      } catch (e) {
        console.warn(e);
      }
    });
  }

  function autoPlayActiveSlideVideo(target) {
    if (!target) {
      return;
    }
    // 暂停所有视频
    pauseAllVideos();
    // 找出当前 active slide（Swiper 会自动加 .swiper-slide-active）
    const activeSlide = target.querySelector(
      ".product-video-swiper .swiper-slide-active"
    );
    if (!activeSlide) {
      return;
    }
    // 找出其中的 iframe
    const iframe = activeSlide.querySelector("iframe");
    if (!iframe) {
      return;
    }
    const iframeSrc = iframe.getAttribute("src") || "";
    // 自动播放逻辑
    if (!iframeSrc.includes("autoplay=1")) {
      const newSrc = iframeSrc.includes("?")
        ? `${iframeSrc}&autoplay=1&mute=1&loop=1`
        : `${iframeSrc}?autoplay=1&mute=1&loop=1`;
      iframe.setAttribute("src", newSrc);
    } else {
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        "*"
      );
    }
  }

  autoPlayActiveSlideVideo(document.querySelector(`.product-content.active`));
});
